import { MeetingsDirectory } from "../../components/meetings/MeetingsDirectory";

function Meetings() {
  return (
    <>
      <MeetingsDirectory />
    </>
  );
}

export default Meetings;
